import { baseApiURL } from "../../Utilities/utility";
import axios from "axios";



export function downloadPDF(siteToken,
    azureToken,
    userId,
    userEmail,
    gid,
    roleName,
    roleId,) {
    const options = {
        method: "post",
        url: baseApiURL + "/Price/DownloadPriceListPDF",
        responseType: "arraybuffer",
       
        headers: {
            

            Accept: "application/json, text/plain, */*",
            "Content-Type": "application/json",
            Authorization: "Bearer " + siteToken.token,
            UserEmail: userEmail,
            RoleName: roleName,
            Gid: gid,
            Roleid: roleId,
            AzureToken: azureToken,
            userId : userId
        },

    };
    return axios(options)
        .then((response) => {
            return response;
            console.log(response);
        })
        .catch((error) => {
            return error;
        });

}